import { render, staticRenderFns } from "./NewClassRoom.vue?vue&type=template&id=7cabeef0&scoped=true&"
import script from "./NewClassRoom.vue?vue&type=script&lang=js&"
export * from "./NewClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./NewClassRoom.vue?vue&type=style&index=0&id=7cabeef0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cabeef0",
  null
  
)

component.options.__file = "NewClassRoom.vue"
export default component.exports